import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import { colors, spacings } from '@fronton/tokens';
import { iconSizeMap } from './constants';
import { choiceIconByType, getStrokeWidth } from './utils';
import style from './style.module.css';
const tokenColorsArray = Object.keys(colors);
export const createIcon = (componentName, iconName, iconGroup, Outline, Fill, Duotone, viewBox = '0 0 24 24') => {
  const Icon = /*#__PURE__*/forwardRef(({
    className,
    size = 'm',
    type = 'outline',
    color = 'currentColor',
    bold = false,
    'data-testid': testId,
    strokeLinecap,
    strokeLinejoin,
    strokeWidth,
    block,
    ...svgProps
  }, ref) => {
    const IconSvg = choiceIconByType(type, Outline, Fill, Duotone);
    const iconSize = useMemo(() => {
      if (typeof size === 'number') {
        return `${size}px`;
      }

      if (size in iconSizeMap) {
        return iconSizeMap[size];
      }

      if (size.startsWith('space-') || size in spacings) {
        return `var(--${size})`;
      }

      return size;
    }, [size]);
    const wrapperClassName = useMemo(() => clsx(style.wrapper, {
      [style.block]: block
    }, className), [className, block]);
    const styles = useMemo(() => {
      let colorCssVar;

      if (tokenColorsArray.includes(color)) {
        colorCssVar = `var(--${color})`;
      } else {
        colorCssVar = color != null ? color : 'inherit';
      }

      const sWidthCssVar = getStrokeWidth(size, strokeWidth, bold);
      return {
        '--i-size': iconSize,
        '--i-color': colorCssVar,
        '--i-s-width': sWidthCssVar
      };
    }, [bold, color, iconSize, size, strokeWidth]);
    svgProps['data-icons-pack'] = 'svg';
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: wrapperClassName,
      style: styles,
      role: "presentation",
      "data-testid": testId,
      "data-icons-pack": "wrapper"
    }, /*#__PURE__*/React.createElement("svg", {
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewBox,
      ...svgProps
    }, /*#__PURE__*/React.createElement(IconSvg, {
      strokeLinecap: strokeLinecap || 'round',
      strokeLinejoin: strokeLinejoin || 'round'
    })));
  });
  Icon.displayName = componentName;
  Icon.iconName = iconName;
  Icon.iconGroup = iconGroup;
  Icon.__iconPack = true;
  return Icon;
};